import { Link } from "react-router-dom";

const NotFound = () => {
  return (
   <div className="nf-page">
    <div className="nf-glow" aria-hidden="true" />

    <div className="nf-content">
        <span className="nf-eyebrow">Error 404</span>
        <h1 className="nf-code">404</h1>
        <h2 className="nf-heading">Page not found</h2>
        <p className="nf-text">
            The page you're looking for doesn't exist or may have been moved.
        </p>

        <Link to="/" className="nf-btn">
            ← Back to login
        </Link>
    </div>

    <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        .nf-page {
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            background: #F7F8F6;
            font-family: 'Inter', sans-serif;
            position: relative;
            overflow: hidden;
            padding: 24px;
        }

        .nf-glow {
            position: absolute;
            width: 520px;
            height: 520px;
            border-radius: 50%;
            background: radial-gradient(circle, rgba(224, 123, 57, 0.14) 0%, rgba(224, 123, 57, 0) 70%);
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            pointer-events: none;
        }

        .nf-content {
            position: relative;
            z-index: 1;
            max-width: 420px;
        }

        .nf-eyebrow {
            display: inline-block;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 0.14em;
            text-transform: uppercase;
            color: #B8632C;
            background: rgba(224, 123, 57, 0.12);
            padding: 5px 12px;
            border-radius: 999px;
            margin-bottom: 20px;
        }

        .nf-code {
            font-size: 96px;
            font-weight: 700;
            line-height: 1;
            color: #e07b39;
            margin: 0 0 12px;
            letter-spacing: -0.02em;
        }

        .nf-heading {
            font-size: 22px;
            font-weight: 700;
            color: #1C2420;
            margin: 0 0 10px;
        }

        .nf-text {
            font-size: 14.5px;
            color: #8B978F;
            line-height: 1.6;
            margin: 0 0 28px;
        }

        .nf-btn {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            background: #e07b39;
            color: #fff;
            font-weight: 600;
            font-size: 14.5px;
            padding: 12px 24px;
            border-radius: 10px;
            text-decoration: none;
            transition: background 0.15s ease, transform 0.15s ease;
        }

        .nf-btn:hover {
            background: #c96a2d;
            color: #fff;
            transform: translateY(-1px);
        }

        @media (max-width: 480px) {
            .nf-code { font-size: 72px; }
        }
    `}</style>
</div>
  );
};

export default NotFound;